import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FuseSplashScreenService } from '@barebone-fuse/@fuse/services/splash-screen.service';
import { CommandService } from '@core/services/command.service';
import { FileManagementService } from '@core/services/file-management.service';
import { TaskMenuDetails } from '@features/task-manager/models/task-manager.model';
import { TaskManagerService } from '@features/task-manager/services/task-manager.service';
import { PlatformCommand, PlatformCommandResponse } from '@shared/commands/command-base';
import { IPlatformToolHandler } from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import { InvalidateSubject } from '@shared/helpers/invalidate.subject';
import { Configuration } from '@shared/models/configuration';
import { GraphqlContentScope } from '@shared/models/graphql-content-scope.model';
import { MagicLinkModel, TabModel } from '@shared/models/platform-tool-models';
import { DialogService } from '@shared/services/dialog-service';
import { take } from 'rxjs/operators';
import { OrbitaxExcelMemoService } from '../orbitax-excel-memo.service';
import {PlatformSidebarState} from '@shared/components/platform-sidebar/store/platform-sidebar.reducer';
import {select, Store} from '@ngrx/store';
import {SetActivityFeedAction} from '@shared/components/platform-sidebar/store/platform-sidebar.action';
import {getApplicationWithId, ParticleState} from '@shared/store/reducers/particle.reduer';
import {DialogModel} from "@shared/models/dialog.model";


@Injectable({
  providedIn: 'root',
})
export class PlatformToolMemoHandler implements IPlatformToolHandler {
  invalidateSubject: InvalidateSubject;
  @Input() magicLinkModel: MagicLinkModel;
  magicLinkModelValueChanged: EventEmitter<any> = new EventEmitter<any>();
  activatedRoute?: ActivatedRoute;
  metaData?: any;
  private selectedTabModel: TabModel;

  constructor(private commandService: CommandService,
    private router: Router,
    private dialogService: DialogService,
    private fuseSplashScreenService: FuseSplashScreenService,
    private fileManagementService: FileManagementService,
    private excelMemoService: OrbitaxExcelMemoService,
    private taskManagerService: TaskManagerService,
    private httpClient: HttpClient,
    private platformSidebarStore: Store<PlatformSidebarState>,
    private store: Store<ParticleState>) { }

  executeCommand(command: PlatformCommand) {
    switch (command.name) {
      case 'CreateEmptyMemoPlatformCommand':
        this.createMemo(command);
        return;
      case 'AttachToReportCommand':
        this.attachToReportTask(command);
        return;
      default:
        this.executeCommandToApi(command);
        return;
      }
  }
  attachToReportTask(command: PlatformCommand) {
    const taskId = command.fieldValues['TicketId'];
    const taskScope = command.fieldValues['BoardScope'];
    const memoId = command.fieldValues['MemoId'];
    const attachPdfToReportCommand = new PlatformCommand('AttachMemoPdfToReportCommand', 'ITRCEApi');
    attachPdfToReportCommand.fieldValues['TicketId'] = taskId;
    attachPdfToReportCommand.fieldValues['MemoId'] = memoId;
    attachPdfToReportCommand.fieldValues['BoardScope'] = taskScope;
    attachPdfToReportCommand.projectId = '[PROJECT_ID]';
    attachPdfToReportCommand.isCamelCase = false;
    //this.executeCommandToApi(attachPdfToReportCommand);

    this.fuseSplashScreenService.show();
    this.commandService.executePlatformCommand(attachPdfToReportCommand).pipe(take(1))
    .subscribe(state => {
      this.fuseSplashScreenService.hide();
      const attachmentMenu = new TaskMenuDetails();
      attachmentMenu.id = 'TaskAttachment';
      this.taskManagerService.openTaskByTaskId(taskId, GraphqlContentScope.getScope(taskScope), null, null, attachmentMenu , false);
    });
  }


  valueChanged(event) {
    console.log('Inside Handler', event);
    if (this.handleAction(event)) {
      return;
    }
    if (this.handleCommand(event)) {
      return;
    }
  }

  private handleCommand($event): boolean {
    if ($event.command) {
      this.executeCommand($event.command);
      return true;
    }
    return false;
  }

  private handleAction(event: any) {
    if ((event.action && event.action.id === 'Open') || (!event.action && event.fieldDefinition.key === 'MemoCode')) {
      console.log(event);
      const command = this.magicLinkModel.additionalCommands['ShowInputMemoCommand'];
      command.fieldValues['MemoId'] = event.item.id;
      this.executeCommandToApi(command);
      return;
    } else if (event.action.id === 'DownloadPdf') {
      const command = this.magicLinkModel.additionalCommands['DownloadMemoPdfCommand'];
      command.fieldValues['MemoId'] = event.item.id;
      this.executeCommandToApi(command);
      return;
    } else if (event.action.id === 'Download') {
      const command = this.magicLinkModel.additionalCommands['DownloadMemoExcelCommand'];
      command.fieldValues['MemoId'] = event.item.id;
      this.executeCommandToApi(command);
      return;
    } else if (event.action.id === 'DownloadWord') {
      const command = this.magicLinkModel.additionalCommands['DownloadMemoWordCommand'];
      command.fieldValues['MemoId'] = event.item.id;
      this.executeCommandToApi(command);
      return;
    } else if (event.action.id === 'View') {
      const command = this.magicLinkModel.additionalCommands['ShowViewMemoCommand'];
      command.fieldValues['MemoId'] = event.item.id;
      this.executeCommandToApi(command);
      return;
    } else if (event.action.id === 'Edit') {
        this.openRenameDialog(event);
    } else if (event.action.id === 'ShowActivity') {
      const referenceCode = event.item.cells['ReferenceCode'].value;
      const referenceTitle = event.item.cells['ReferenceTitle'].displayText;
      const activityInfo = {type: 'ReferenceCode', 'id': referenceCode, 'title': referenceTitle, isDefault: false, isUserAction: true};
      this.platformSidebarStore.dispatch(new SetActivityFeedAction(activityInfo));
    } else if (event.action === 'Refresh') {
      switch (event.name) {
        case 'RefreshBreadcrumbBar':
          this.refreshBreadCrumbBar();
          break;
        default:
          break;
      }
    }
    return false;
  }

  private executeCommandToApi(command: PlatformCommand) {
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
          this.fuseSplashScreenService.hide();

          if (commandResponse.fieldValues['RedirectUrl']) {
            this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
          } else if (commandResponse.fieldValues['DownloadFileId']) {
            this.dowloadFile(commandResponse);
          } else if (commandResponse.fieldValues['RedirectCommand']) {
            this.executeCommand(commandResponse.fieldValues['RedirectCommand']);
          } else if (commandResponse.fieldValues['PlatformLinkModel']) {
            this.magicLinkModelValueChangedHandler({
              id: 'PlatformToolContainerComponent',
              value: commandResponse.fieldValues['PlatformLinkModel']
            });
            return;
          } else if (commandResponse.fieldValues['RefreshBreadcrumbBar']) {
            this.refreshBreadCrumbBar();
          } else {
            this.invalidateSubject.invalidate();
          }
        },
        error => {
          console.error('Failed ToolBarComponent command', error);
          this.fuseSplashScreenService.hide();
        });
    }
  }

  dowloadFile(commandResponse: PlatformCommandResponse) {
    this.fuseSplashScreenService.show();
    const fileId = commandResponse.fieldValues['DownloadFileId'];
    const title = commandResponse.fieldValues['Title'];
    this.fileManagementService.downloadClientFileWithId(fileId).subscribe( payload => {
      this.fuseSplashScreenService.hide();
      this.fileManagementService.openSaveFileWindow(payload, `${title}`);
    });
  }

  private magicLinkModelValueChangedHandler(command: any) {
    this.magicLinkModelValueChanged.emit(command);
  }

  createMemo(command: PlatformCommand) {
    this.dialogService.showTextInputDialog('Create Memo', '', null, null, 'Title').subscribe(res => {
      if (res.action === 'OK') {
        console.log(res.data.input.text);
        command.fieldValues['Title'] = res.data.input.text;
        this.executeCommandToApi(command);
      }
    });
  }

  refreshBreadCrumbBar() {
    this.fetchMagicLink((data: any) => {
      const payload: any = {id: 'BreadcrumbBarComponent', value: this.magicLinkModel['breadcrumbBar']};
      this.magicLinkModelValueChangedHandler(payload);
    });
  }

  fetchMagicLink(callback: any) {
    const id = this.magicLinkModel.id;
    this.httpClient.get<MagicLinkModel>(`${Configuration.getConfig('ITRCEApi')}Platform/LinkById?id=${id}`).pipe(take(1)).subscribe(
      data => {
        this.magicLinkModel = data;
        callback(data);
      },
      error => {
        this.fuseSplashScreenService.hide();
        console.error('flowchart get sections error', error);
      }
    );
  }

  private openRenameDialog(event: any) {
    const fieldDefinition = event.fieldDefinition;
    const existingTitle = event.item.cells[fieldDefinition.key].displayText;
    this.dialogService
      .showTextInputDialog(
        `Rename ${fieldDefinition.header}`, existingTitle, '', 50, `${fieldDefinition.header}`
      )
      .pipe(take(1))
      .subscribe((state) => {
        if (state.action === 'OK') {
          const command = this.magicLinkModel.additionalCommands['UpdateRateMemoCommand'];
          command.fieldValues['MemoId'] = event.item.id;
          command.fieldValues[fieldDefinition.key] =  state.data.input.text;
          this.executeCommandToApi(command);
        }
      });
  }
  setSelectedTab(selectedTab: TabModel): void {
    this.selectedTabModel = selectedTab;
  }
  destroy(): void {
  }
  selectionChanged?($event: any): void {
  }
  onFieldSectionChanged?($event: any): void {
  }
  onFieldSectionIndexChanged?($event: any): void {
  }
}
